var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "section main-section" }, [
    _c(
      "div",
      { staticClass: "container" },
      [
        _c("title-comp", { attrs: { name: _vm.$t("title.login") } }),
        _c("div", { staticClass: "form-container form-login" }, [
          _c(
            "div",
            {
              staticClass: "has-text-centered is-unselectable margin-bottom-md",
            },
            [_vm._v(_vm._s(_vm.$t("auth.has_account_desc")))]
          ),
          _vm.userPromoCode
            ? _c("div", { staticClass: "field" }, [
                _c("p", { staticClass: "control has-icons-left" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.userPromoCode,
                        expression: "userPromoCode",
                      },
                    ],
                    staticClass: "input",
                    attrs: { type: "text", disabled: "" },
                    domProps: { value: _vm.userPromoCode },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.userPromoCode = $event.target.value
                      },
                    },
                  }),
                  _c(
                    "span",
                    { staticClass: "icon is-small is-left" },
                    [_c("gift-icon", { attrs: { size: "1.5x" } })],
                    1
                  ),
                ]),
              ])
            : _vm._e(),
          _c("div", { staticClass: "field" }, [
            _c("p", { staticClass: "control has-icons-left" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.email,
                    expression: "email",
                  },
                ],
                staticClass: "input",
                attrs: {
                  type: "email",
                  placeholder: _vm.$t("placeholder.email"),
                },
                domProps: { value: _vm.email },
                on: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.submitOrTabLogin.apply(null, arguments)
                  },
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.email = $event.target.value
                  },
                },
              }),
              _c(
                "span",
                { staticClass: "icon is-small is-left" },
                [_c("mail-icon", { attrs: { size: "1.5x" } })],
                1
              ),
            ]),
          ]),
          _c("div", { staticClass: "field has-addons" }, [
            _c("p", { staticClass: "control has-icons-left is-expanded" }, [
              (_vm.hidden ? "password" : "text") === "checkbox"
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.password,
                        expression: "password",
                      },
                    ],
                    ref: "inputPassword",
                    staticClass: "input",
                    attrs: {
                      placeholder: _vm.$t("placeholder.password"),
                      type: "checkbox",
                    },
                    domProps: {
                      checked: Array.isArray(_vm.password)
                        ? _vm._i(_vm.password, null) > -1
                        : _vm.password,
                    },
                    on: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.submitLogin.apply(null, arguments)
                      },
                      change: function ($event) {
                        var $$a = _vm.password,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 && (_vm.password = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.password = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.password = $$c
                        }
                      },
                    },
                  })
                : (_vm.hidden ? "password" : "text") === "radio"
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.password,
                        expression: "password",
                      },
                    ],
                    ref: "inputPassword",
                    staticClass: "input",
                    attrs: {
                      placeholder: _vm.$t("placeholder.password"),
                      type: "radio",
                    },
                    domProps: { checked: _vm._q(_vm.password, null) },
                    on: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.submitLogin.apply(null, arguments)
                      },
                      change: function ($event) {
                        _vm.password = null
                      },
                    },
                  })
                : _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.password,
                        expression: "password",
                      },
                    ],
                    ref: "inputPassword",
                    staticClass: "input",
                    attrs: {
                      placeholder: _vm.$t("placeholder.password"),
                      type: _vm.hidden ? "password" : "text",
                    },
                    domProps: { value: _vm.password },
                    on: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.submitLogin.apply(null, arguments)
                      },
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.password = $event.target.value
                      },
                    },
                  }),
              _c(
                "span",
                { staticClass: "icon is-small is-left" },
                [_c("lock-icon", { attrs: { size: "1.5x" } })],
                1
              ),
            ]),
            _c("p", { staticClass: "control" }, [
              _c(
                "a",
                { staticClass: "button", on: { click: _vm.toggleHidden } },
                [
                  _vm.hidden
                    ? _c("eye-icon", { attrs: { size: "1.5x" } })
                    : _c("eye-off-icon", { attrs: { size: "1.5x" } }),
                ],
                1
              ),
            ]),
          ]),
          _c("div", { staticClass: "field margin-top-md" }, [
            _c("p", { staticClass: "control has-text-centered" }, [
              _c(
                "button",
                {
                  staticClass: "button is-primary",
                  class: _vm.buttonClass,
                  attrs: { type: "button" },
                  on: { click: _vm.submitLogin },
                },
                [_vm._v(_vm._s(_vm.$t("button.login")))]
              ),
            ]),
          ]),
          _vm.errorEmail
            ? _c(
                "article",
                {
                  staticClass: "message is-danger",
                  attrs: { transition: "fade" },
                },
                [
                  _c("div", { staticClass: "message-body" }, [
                    _vm._v(_vm._s(_vm.$t("alert.missing_email"))),
                  ]),
                ]
              )
            : _vm.errorPassword
            ? _c(
                "article",
                {
                  staticClass: "message is-danger",
                  attrs: { transition: "fade" },
                },
                [
                  _c("div", { staticClass: "message-body" }, [
                    _vm._v(_vm._s(_vm.$t("alert.missing_password"))),
                  ]),
                ]
              )
            : _vm.errorAuth
            ? _c(
                "article",
                {
                  staticClass: "message is-danger",
                  attrs: { transition: "fade" },
                },
                [
                  _c("div", { staticClass: "message-body" }, [
                    _vm._v(_vm._s(_vm.$t("alert.invalid_login"))),
                  ]),
                ]
              )
            : _c("div", { staticClass: "field margin-top-md" }, [
                _c(
                  "p",
                  { staticClass: "control has-text-centered" },
                  [
                    _vm._v(_vm._s(_vm.$t("auth.password_forget"))),
                    _c("router-link", { attrs: { to: "/password-restore" } }, [
                      _vm._v(_vm._s(_vm.$t("button.click_here"))),
                    ]),
                  ],
                  1
                ),
              ]),
        ]),
        _c(
          "div",
          {
            staticClass: "form-container form-login margin-top-xs",
            staticStyle: {
              "background-color": "transparent",
              padding: "0 !important",
              "box-shadow": "none",
              border: "0",
              "text-align": "right",
            },
          },
          [
            _c("router-link", { attrs: { to: "/" } }, [
              _c(
                "span",
                { staticClass: "icon icon-left feather" },
                [_c("chevron-left-icon")],
                1
              ),
              _vm._v(_vm._s(_vm.$t("button.back_home"))),
            ]),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }